import { initialState } from "./initialState";
import {
  FETCH_COMPONENTS_REQUEST,
  FETCH_FILTERED_BATCH_LIST,
  FETCH_GENEALOGY_REPORT,
  FETCH_GENEALOGY_REPORT_BY_ID,
  FETCH_GENEALOGY_REPORT_LIST_REQUEST,
  FETCH_MANUFACTURING_SITES_REQUEST,
  FETCH_PARAMETERS_REQUEST,
  FETCH_PRODUCED_PRODUCTS_REQUEST,
  FETCH_PRODUCT_DESCRIPTION_REQUEST,
  FETCH_UNIT_OPERATIONS_REQUEST,
  REPORT_DATA,
  SAVE_REPORT_DATA,
} from "./types";

const batchReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GENEALOGY_REPORT_LIST_REQUEST:
      return { ...state, genealogyList: action.payload };

    case FETCH_PRODUCED_PRODUCTS_REQUEST:
      return { ...state, genealogyProducedProducts: action.payload };

    case FETCH_MANUFACTURING_SITES_REQUEST:
      return { ...state, genealogyManufacturingSites: action.payload };

    case FETCH_UNIT_OPERATIONS_REQUEST:
      return { ...state, genealogyUnitOperations: action.payload };

    case FETCH_PRODUCT_DESCRIPTION_REQUEST:
      return { ...state, genealogyProductDescriptions: action.payload };

    case FETCH_PARAMETERS_REQUEST:
      return { ...state, genealogyParameters: action.payload };

    case FETCH_COMPONENTS_REQUEST:
      return { ...state, genealogyComponents: action.payload };

    case FETCH_GENEALOGY_REPORT:
      return {
        ...state,
        reportDetails: action.payload,
      };

    case FETCH_FILTERED_BATCH_LIST:
      return {
        ...state,
        filteredBatchList: action.payload,
      };

    case REPORT_DATA:
      return {
        ...state,
        reportData: action.payload,
      };

    case SAVE_REPORT_DATA:
      return {
        ...state,
        savedReportDetails: action.payload,
      };

    case FETCH_GENEALOGY_REPORT_BY_ID:
      return {
        ...state,
        savedReportDetails: action.payload,
      };

    default:
      return state;
  }
};

export default batchReducer;
